export type MetaDataWaterPrivacyStatus = 'danger' | 'warning' | 'default';

export interface MetadataType {
  description: string;
  name: string;
  variant: MetaDataWaterPrivacyStatus;
}

export const getWaterPrivacyStatusFromMetadata = (
  metadata: MetadataType[],
): MetaDataWaterPrivacyStatus => {
  if (metadata.length === 0) {
    return 'default';
  }

  if (metadata.find(metaObj => metaObj.variant === 'danger')) {
    return 'danger';
  }

  if (metadata.find(metaObj => metaObj.variant === 'warning')) {
    return 'warning';
  }

  return 'default';
};
